export function Autocomplete(value, itens, params) {
  let newResults = [];
  for (let s in itens) {
    const item = itens[s];
    for(let param of params){
      console.log("Parametro", param)
      if(item[param] !== undefined && item[param] !== null){
        const info = item[param].toLowerCase();
        if (info.includes(value.toLowerCase()) && newResults.filter(x => x.id === item.id).length == 0) {
          newResults.push(item);
        }
      }
    }
  }
  console.log("Pesquisa", newResults);
  return newResults;
}
